/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import { News } from "../../redux/newsfeed/NewsfeedInterface";
import Heading2 from "../common/text/Heading2";
import Underline, { UnderlinePositionEnum } from "../common/Underline";
import Container from "../layout/Container";
import GrayCalendarIcon from "../../icons/gray-calendar.svg";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { parseJSON } from "date-fns";
import Gallery from "react-photo-gallery";
import { useState } from "react";

import { YouTubeEmbed } from "react-social-media-embed";

const YOUTUBE_DEFAULT_HEIGHT = 480;

export const NewsSection = ({ news }: { news: News }) => {
  const url = process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL
    ? news.Glavna_slika?.formats
      ? process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL + news.Glavna_slika.url
      : "/img/news-no-image-bigger.png"
    : "/img/news-no-image-bigger.png";
  const dateObj = parseJSON(news.createdAt);

  const imgs = news?.Galerija?.map((photo) => {
    return {
      src: process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL + photo.url,
      height: 1,
      width: 1,
    };
  });

  const [embedHeight, setEmbedHeight] = useState(YOUTUBE_DEFAULT_HEIGHT);

  return (
    <Container>
      <div className="mb-8">
        <Heading2>{news.Naslov}</Heading2>
        <Underline position={UnderlinePositionEnum.center} color="blueAccent" />
      </div>
      {news?.Glavna_slika?.url && news?.Glavna_slika?.url.trim().length > 0 && (
        <div className="relative w-auto h-auto  mb-4  rounded-lg">
          <img
            src={url}
            alt={"vijest"}
            width={news.Glavna_slika.width || 0}
            height={news.Glavna_slika.height || 0}
            className="mx-auto rounded-lg max-h-[480px]"
            style={{ objectFit: "contain" }}
          />
        </div>
      )}
      <div className="flex flex-row items-center gap-1 mb-[14px]">
        <div>
          <Image src={GrayCalendarIcon} alt="c" width={13} height={14} />
        </div>
        <div className="font-roboto font-medium text-[12px] leading-[14.06px] text-[#B0B0B0]">
          {`${dateObj.getDate().toString()}.${dateObj
            .getMonth()
            .toString()}.${dateObj.getFullYear().toString()}.`}
        </div>
      </div>
      <div className="flex flex-col gap-[26px] mb-20">
        <BlocksRenderer
          content={news?.Sadrzaj || []}
          blocks={{
            paragraph: ({ children }) => (
              <>
                <p className="font-roboto font-light text-[18px] leading-[26px] text-black">
                  {children}
                </p>
              </>
            ),
          }}
        />
      </div>
      {imgs && imgs.length > 0 && (
        <div className="mb-16">
          <Gallery photos={imgs} />
        </div>
      )}
      {news.Putanja_youtube_snimka &&
        news.Putanja_youtube_snimka.trim().length > 0 && (
          <div className="mx-auto max-w-[854px]">
            <YouTubeEmbed
              url={news.Putanja_youtube_snimka}
              height={embedHeight}
              width={"100%"}
              youTubeProps={{
                onReady: async (r) =>
                  (await r.target.getIframe()).addEventListener("load", () =>
                    setEmbedHeight((height) => height + 1)
                  ),
              }}
            />
          </div>
        )}
    </Container>
  );
};
